// extracted by mini-css-extract-plugin
export default {"root":"InsightCard_root__-ZJaP","infoContent":"InsightCard_infoContent__VjX+-","thread":"InsightCard_thread__1ZDTp"};